import * as React from 'react'
import {mmap} from '@freckle/maybe'

// Components
import LabelWithValue from '@frontrow/console/src/components/common/label-with-value'
// Models
import {type SchoolAttrs} from '@frontrow/console/src/models/school'
// Helpers
import {dateAccessor} from '@frontrow/console/src/helpers/formatters'
// Styles
import * as style from './school-profile.module.scss'

type Props = {
  school: SchoolAttrs
}

export default function SchoolProfile(props: Props): React.ReactElement {
  const {id, name, createdAt, formattedAddressLines} = props.school

  return (
    <div className={style.schoolProfileContainer}>
      <LabelWithValue name="ID" value={id} />
      <LabelWithValue name="School name" value={name} />
      <LabelWithValue
        name="Address Lines"
        value={mmap(a => a.map((a, i) => <p key={i}>{a}</p>), formattedAddressLines)}
      />
      <LabelWithValue name="Created at" value={dateAccessor(createdAt)} />
    </div>
  )
}
